const InitialState = null

const ProductsData = (state = InitialState, action) => {
    switch (action.type) {
        case "ADD_PRODUCT_DATA":
            return state = action.data
            break;
        default:
            return state
            break;
    }

}

export default ProductsData